// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27ygI","comment":"styles_comment__PpilP"};